import { Stack } from "@/core/components/ui/stack";
import { Typography } from "@/core/components/ui/typography";
import { stAdjustmentsPreviewLinesFor } from "./preview-data";
import { TechnicianAdjustmentLine } from "./technician-adjustment-line";
import { TechnicianSidebarHeader } from "./technician-sidebar-header";
import type { StAdjustmentTechnicianGroup } from "./types";

export const StAdjustmentsPreviewSidebar = ({
  group,
  onClose,
}: {
  group: StAdjustmentTechnicianGroup | null;
  onClose: () => void;
}) => {
  if (!group) return null;

  const lines = stAdjustmentsPreviewLinesFor(group);

  return (
    <Stack gap="none" fullWidth className="h-full opacity-75">
      <TechnicianSidebarHeader group={group} onClose={onClose} />

      <Stack gap="md" fullWidth className="min-h-0 flex-1 overflow-y-auto p-5">
        {lines.map((line) => (
          <TechnicianAdjustmentLine
            key={line.jobNumber}
            jobNumber={line.jobNumber}
            amountCents={line.amountCents}
            category={line.category}
            memo={line.memo}
          />
        ))}

        <Typography variant="captionW1" textColor="secondary">
          Showing {lines.length} of {group.pending}
        </Typography>
      </Stack>
    </Stack>
  );
};
